import { NumberInput } from '@mantine/core';
import { FieldValues, useController } from 'react-hook-form';

import { FormControlInput } from '@/core/components';

export interface NumberInputControlProps<T extends FieldValues> extends FormControlInput<T> {
  withAsterisk?: boolean;

  label: string;
  description?: string | null;
  placeholder?: string;

  isDisabled?: boolean;

  min?: number;
  max?: number;
  allowDecimal?: boolean;

  flex?: number;
}

export function NumberInputControl<T extends FieldValues>(props: NumberInputControlProps<T>) {
  const {
    withAsterisk,
    label,
    placeholder,
    description,
    name,
    isSubmitting,
    isDisabled,
    min,
    max,
    allowDecimal,
    flex,
    control,
  } = props;
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });
  return (
    <NumberInput
      ref={field.ref}
      name={field.name}
      value={field.value == null ? '' : String(field.value)}
      onChange={newNo => field.onChange(newNo == '' ? null : Number(newNo))}
      label={label}
      description={description}
      placeholder={placeholder ?? label}
      withAsterisk={withAsterisk}
      error={error?.message}
      disabled={isSubmitting || isDisabled}
      min={min ?? 0}
      max={max}
      allowDecimal={allowDecimal}
      fixedDecimalScale={allowDecimal}
      decimalScale={allowDecimal ? 2 : undefined}
      flex={flex ?? 1}
    />
  );
}
